export default "__VITE_ASSET__97f3f98b__"